var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import ReactDOM from "react-dom/client";
import ZipCheckResults from "../components/ZipCheckResults";
class DeliveryCheck extends React.Component {
    constructor(props) {
        super(props);
        this.zipCheckChange = (event) => {
            this.setState({
                zipCheck: event.target.value
            });
        };
        this.zipCheckKeyDown = (event) => {
            if (event.key == "Enter") {
                event.preventDefault();
                this.performZipCheck();
            }
        };
        this.performZipCheck = () => __awaiter(this, void 0, void 0, function* () {
            const { zipCheck } = this.state;
            this.setState({
                checkingZip: true
            });
            const response = yield fetch(`/ajax/checkDeliveryPostcode?pcode=${zipCheck}`);
            const data = yield response.json();
            setTimeout(() => {
                this.setState({
                    checkingZip: false,
                    zipResult: data.can_deliver,
                    showZipMessage: true
                });
            }, 0);
        });
        this.state = {
            zipCheck: "",
            checkingZip: false,
            showZipMessage: false,
            zipResult: false
        };
    }
    render() {
        const { zipCheck, checkingZip, showZipMessage, zipResult } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "input-group mb-3" },
                React.createElement("input", { type: "text", className: "form-control", placeholder: "Enter your ZIP code", name: "zipCheck", value: zipCheck, id: "zipCheck", onChange: this.zipCheckChange, onKeyDown: this.zipCheckKeyDown }),
                React.createElement("button", { className: "btn btn-light", type: "button", id: "zipCheck-btn", onClick: this.performZipCheck }, "Submit")),
            React.createElement(ZipCheckResults, { checkingZip: checkingZip, showZipMessage: showZipMessage, zipResult: zipResult })));
    }
}
// ─── Initialisation ─────────────────────────────────────────────────────────────
const checkForm = document.getElementById("standalone-delivery-check");
if (checkForm) {
    const checkRoot = ReactDOM.createRoot(checkForm);
    checkRoot.render(React.createElement(DeliveryCheck, null));
}
